import { api } from "../api";
import { getCustomerAsync } from "../customer";

const company = localStorage.getItem("company");

export const getAllOrders = (lockerId, filter, callback) => {
  let URL = `/lockers/${lockerId}/orders?filter[lockerId]=${lockerId}${filter}`;

  api
    .get(URL)
    .then((response) => {
      callback(replaceIdCaracter(response.data.data));
    })
    .catch((error) => {
      callback([]);
      console.log("Error:. " + error);
    });
};

export const getAllOrdersFilter = (lockerId, codeOrder, statusO, selectedDateInit, selectedDateFinal, callback) => {

  let URL = `/lockers/${lockerId}/orders/filter`;

  const startOfDay = new Date(selectedDateInit);
  startOfDay.setUTCHours(0, 0, 0, 0);

  const endOfDay = new Date(selectedDateFinal);
  endOfDay.setDate(endOfDay.getDate() + 1);
  endOfDay.setUTCHours(23, 59, 59, 999);


  let data = {
    "code": codeOrder,
    "status": statusO,
    "initialDate": startOfDay.toISOString(),
    "finalDate": endOfDay.toISOString()
  };

  console.log("FILTER:", JSON.stringify(data));

  api
    .post(URL, data)
    .then((response) => {
      callback(replaceIdCaracter(response.data));
    })
    .catch((error) => {
      callback([]);
      // console.log("Error:. " + error);
    });
};

export const getAllActiveOrders = (lockerId, callback) => {
  let URL = `/lockers/${lockerId}/active-orders`;
  console.log(URL)
  api
    .get(URL)
    .then((response) => {
      callback(replaceIdCaracter(response.data));
    })
    .catch((error) => {
      callback([]);
      console.log("Error:. " + error);
    });
};

export const getOrdersbyStatus = (lockerId, status, callback) => {
  let url = `/lockers/${lockerId}/orders?status=${status}`;
  api
    .get(url)
    .then(function (response) {
      callback(
        company === "socicam"
          ? response.data.data.orders
          : replaceIdCaracter(response.data.data)
      );
    })
    .catch(function (error) {
      console.log("getOrderbySlotID => Error: " + error);
      callback([]);
    });
};

export const getOrdersbyStatusAsync = async (lockerId, status) => {
  let url = `/lockers/${lockerId}/orders?status=${status}`;
  let response = await api.get(url);
  return response.data.data.orders ? response.data.data.orders : [];
};

export const getOrdersCustomersbyStatusAsync = async (lockerId, status) => {
  let url = `/lockers/${lockerId}/orders?status=${status}`;
  let response = await api.get(url);

  console.log("response.data.data.orders:: ", response.data.data.orders);

  const _orders = response.data.data.orders ? response.data.data.orders : [];

  return new Promise((resolve, reject) => {
    let orders = [];
    _orders.forEach(async (element) => {
      if (orders.length === _orders.length) resolve(orders);
    });
  });
};

export const getOrderbySlotID = (lockerId, slotId, status, callback) => {
  let url = `/lockers/${lockerId}/orders?status=${status}&slotId=${slotId}`;
  api
    .get(url)
    .then(function (response) {
      callback(
        company === "socicam"
          ? response.data.data.orders
          : replaceIdCaracter(response.data.data)
      );
    })
    .catch(function (error) {
      console.log("getOrderbySlotID => Error: " + error);
      callback([]);
    });
};

export const createOrder = (order, callback) => {
  console.log("order", order);
  let { size, email, mobile_phone, cpf, numero_pedido, lockerId, clientName, collectToken, deliveryToken, label } = order;

  let URL = `/lockers/${lockerId}/orders`;


  let _user = localStorage.getItem('user')
  _user = JSON.parse(_user);

  let data = {
    lockerId,
    size,
    email,
    mobile_phone,
    cpf,
    externalOrderId: numero_pedido,
    lockerType: 'ecommerce',
    user_id: _user.data.id,
    clientName,
    collectToken,
    deliveryToken,
    label
  };

  api
    .post(URL, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callback(400);
      console.log("Error:. " + error);
    });
};

export const deleteOrder = (orderId, callback) => {
  let URL = `/inpost/orders/${orderId}`;

  api
    .delete(URL)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((error) => {
      callback(null);
      console.log("Error:. " + error);
    });
};

export const getOrderById = (lockerId, orderId, callback) => {
  let URL = `/lockers/${lockerId}/orders/${orderId}`;

  api
    .get(URL)
    .then((response) => {
      callback(
        company === "socicam"
          ? response.data.data.order
          : replaceIdCaracter(response.data.data)
      );
    })
    .catch((error) => {
      callback(null);
      console.log("Error:. " + error);
    });
};

export const intransitOrder = (AWB, callback) => {
  let URL = `/inpost/orders/${AWB}/intransit`;

  api
    .put(URL)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((error) => {
      callback(null);
      console.log("Error:. " + error);
    });
};

export const cancelOrder = (lockerId, orderId, callback) => {
  let URL = `/lockers/${lockerId}/orders/${orderId}/cancel`;

  api
    .post(URL)
    .then((response) => {
      callback(response.status);
    })
    .catch((error) => {
      callback(null);
      console.log("Error:. " + error);
    });
};

export const getCustomer = function (filter, callback) {
  const URL = filter ? `/customer/?${filter}` : `/customer`;

  api
    .get(URL)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((error) => {
      callback([]);
      console.log("Error:. " + error);
    });
};

export const getOrderByCustomerId = (
  customerId,
  status,
  lockerId,
  callback
) => {
  let URL = status
    ? `/lockers/${lockerId}/orders?filter[customerId]=${customerId}&filter[lockerId]=${lockerId}&filter[status]=${status}`
    : `/lockers/${lockerId}/orders?filter[customerId]=${customerId}&filter[lockerId]=${lockerId}`;

  api
    .get(URL)
    .then((response) => {
      callback(
        company === "socicam"
          ? response.data.data.orders
          : replaceIdCaracter(response.data.data)
      );
    })
    .catch((error) => {
      callback(null);
      console.log("Error:. " + error);
    });
};

export const replaceIdCaracter = (data) => {
  let rename = ({ _id: id, ...rest }) => ({ id, ...rest });

  if (Array.isArray(data)) {
    let dataModfified = [];

    data.map((d) => dataModfified.push(rename(d)));

    return dataModfified;
  } else {
    return rename(data);
  }
};

export const getOrdersFilteredByMonthYear = (lockerId, allocatedAtYear, allocatedAtMonth, callback) => {
  let URL = `/lockers/${lockerId}/orders?allocatedAtYear=${allocatedAtYear}&allocatedAtMonth=${allocatedAtMonth}`;

  api
    .get(URL)
    .then((response) => {
      callback(replaceIdCaracter(response.data.data));
    })
    .catch((error) => {
      callback([]);
      console.log("Error:. " + error);
    });
};


export const updateOrder = (lockerId, orderId, data, callback) => {
  const URL = `/lockers/${lockerId}/orders/${orderId}`;

  console.log("URL: ", URL, " Data: ", JSON.stringify(data));

  api
    .put(URL, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback([]);
      console.log("Error:. " + error);
    });
};

export const updateOrderFull = (lockerId, orderId, data, callback) => {
  const URL = `/lockers/${lockerId}/orders/${orderId}/condomino`;

  console.log("URL: ", URL, " Data: ", JSON.stringify(data));

  api
    .put(URL, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callback([]);
      console.log("Error:. " + error);
    });
};